<div class="cursor-pointer flex items-center" [matMenuTriggerFor]="menu">
  <div
    class="relative w-10 h-10 overflow-hidden bg-gray-100 rounded-full"
  >
    <svg
      class="absolute w-12 h-12 text-gray-400 -left-1 text-primary-500"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fill-rule="evenodd"
        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
        clip-rule="evenodd"
      ></path>
    </svg>
  </div>
  <pulse-icon class="pl-3" [size]="14" icon="arrow_down"></pulse-icon>
</div>

<mat-menu #menu>
  <button *ngIf="showMyAccount" (click)='goToMyAccount()' class="flex items-center" mat-menu-item>
    <span>My account</span>
  </button>
  <button (click)='closeSession()' class="flex items-center" mat-menu-item>
    <span>Sign out</span>
  </button>
</mat-menu>
